import React, { Component } from "react";
import Client from "../Client";
import BlackLoading from "../images/black-loader.gif";
import marked from "marked"; //to make font bold and headings
import {Link} from 'react-router-dom';
import FallFunFlashImages from "./FallFunFlashImages";

class FallFun extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fallfunpage: [],
    };
  }

  componentDidMount() {
    Client.getEntries({
      content_type: "fallfunNew",
    }).then((entries) => {
      this.setState({ fallfunpage: entries.items });
    });
  }

  //to make font bold and headings
  getParsedMarkdown(fallfunDescription) {
    return {
      __html: marked(fallfunDescription, { sanitize: false }),
    };
  }
  //to make font bold and headings - end

  render() {
    return (
      <>
      <div className="container-fluid">
        {this.state.fallfunpage.length === 0 ? (
          <div align="center">
            <img src={BlackLoading} alt="Loading..." />
          </div>
        ) : (
          <div className="row">
            {this.state.fallfunpage.map((item, index) => {
              return (
                <div key={index} className="col-lg-12">
                  <div className="text-left pt-2">
                    <h1 className="text-uppercase">{item.fields.fallfunTitle}</h1>
                    <h2 className="lead">{item.fields.fallfunShortDetails}</h2>
                  </div>

                  <div className="pt-2">
                    <div className="row">
                      <div className="col-lg-4">
                        <img
                          className="img-fluid"
                          src={item.fields.fallfunImg.fields.file.url}
                          alt="fall fun"
                        />
                        
                      </div>
                      <div className="col-lg-8">
                        {/* <p>{item.fields.aboutDescription}</p> */}
                        <div dangerouslySetInnerHTML = {this.getParsedMarkdown(
                            item.fields.fallfunDescription
                        )}></div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

          <div className="pt-4">
            <Link to="/fall-fun-gallery"><FallFunFlashImages/></Link>  
          </div>

      {/* <div className="pt-4">
        <Link to="/fall-fun-gallery"><button className="btn btn-primary">View Gallery</button></Link>
      </div> */}
      </div>
      </>
    );
  }
}

export default FallFun;
